/* eslint-disable react/prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import Table, { TableSize } from '@components/Table';
import { translate } from '@utils/i18n';
import { Button } from '@ui';
import TooltipText from '@components/v2/TooltipText';
import { useToggleComponentQuestionSetStatusMutation } from './hooks/useComponentQuestionSetsMutations';
const namespace = 'features.settings.component_questions';
function QuestionSetRenderer({ item }) {
    return (React.createElement("div", { className: "component-question-set-row" },
        React.createElement("div", { className: "component-question-set-info" },
            React.createElement("div", { className: "component-question-set-name" }, item.name))));
}
function ActionsRenderer({ item, onEditClick }) {
    const editLabel = translate('edit', { namespace: 'generic' });
    const toggleLabel = item.active
        ? translate('deactivate', { namespace: 'features.commons' })
        : translate('activate', { namespace: 'features.commons' });
    const toggleMutation = useToggleComponentQuestionSetStatusMutation();
    const handleEditClick = () => {
        if (onEditClick) {
            onEditClick(item);
        }
    };
    const handleToggleClick = () => {
        toggleMutation.mutate(item.id);
    };
    return (React.createElement("div", { className: "component-actions-row" },
        React.createElement(TooltipText, { text: editLabel, position: "top" },
            React.createElement(Button, { "aria-label": `${editLabel} ${item.name}`, onClick: handleEditClick },
                React.createElement("i", { className: "fa-light fa-pencil", "aria-hidden": "true" }))),
        React.createElement(TooltipText, { text: toggleLabel, position: "top" },
            React.createElement(Button, { "aria-label": `${toggleLabel} ${item.name}`, onClick: handleToggleClick, disabled: toggleMutation.isLoading }, toggleMutation.isLoading ? (React.createElement("i", { className: "fa fa-spinner fa-spin", "aria-hidden": "true" })) : (React.createElement("i", { className: item.active ? 'fa-light fa-ban' : 'fa-light fa-check-circle', "aria-hidden": "true" }))))));
}
export default function ComponentQuestionsTable({ questionSets, onEditClick }) {
    const columns = [
        {
            label: translate('question_set_column', { namespace }),
            dataKey: 'name',
            renderer: (props) => React.createElement(QuestionSetRenderer, { item: props.item })
        },
        {
            label: translate('questions_count_column', { namespace }),
            dataKey: 'questionsCount',
            renderer: (props) => React.createElement("span", null, props.item.questionsCount)
        },
        {
            label: translate('component_types_count_column', { namespace }),
            dataKey: 'componentTypesCount',
            renderer: (props) => React.createElement("span", null, props.item.componentTypesCount)
        },
        {
            label: '',
            dataKey: 'actions',
            renderer: (props) => (React.createElement(ActionsRenderer, { item: props.item, onEditClick: onEditClick }))
        }
    ];
    const sortedQuestionSets = [...questionSets].sort((a, b) => a.name.localeCompare(b.name));
    return React.createElement(Table, { columns: columns, data: sortedQuestionSets, size: TableSize.Full, variant: "detail" });
}
